// extracted by mini-css-extract-plugin
module.exports = {"button-fal":"ButtonFal_button-fal__m5hit","button-fal-max":"ButtonFal_button-fal-max__ZaDOk"};